// extracted by mini-css-extract-plugin
export default {"container":"product-contains-description__container___2ym-v","icon":"product-contains-description__icon___2LDwo"};